import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const RefreshIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M1.5 8C1.5 6.27609 2.18433 4.62231 3.40332 3.40332C4.62231 2.18433 6.27609 1.5 8 1.5H8.00195L8.33984 1.50977C10.0233 1.59744 11.6233 2.28991 12.8408 3.4668L14.3535 4.97949C14.5487 5.1747 14.5486 5.49125 14.3535 5.68652C14.1583 5.88179 13.8417 5.88179 13.6465 5.68652L12.1455 4.18652L11.9326 3.99023C10.8464 3.03707 9.44964 2.50546 7.99805 2.5C6.54006 2.50052 5.14232 3.08034 4.11133 4.11133C3.07988 5.14278 2.5 6.54131 2.5 8C2.5 8.27614 2.27614 8.5 2 8.5C1.72386 8.5 1.5 8.27614 1.5 8Z"
      fill="currentColor"
    />
    <path
      d="M13.4997 2C13.4997 1.72397 13.7237 1.50018 13.9997 1.5C14.2758 1.5 14.4997 1.72386 14.4997 2V5.33301C14.4997 5.60915 14.2758 5.83301 13.9997 5.83301H10.6667C10.3905 5.83301 10.1667 5.60915 10.1667 5.33301C10.1668 5.05702 10.3906 4.83301 10.6667 4.83301H13.4997V2Z"
      fill="currentColor"
    />
    <path
      d="M13.5 8C13.5 7.72386 13.7239 7.5 14 7.5C14.2761 7.5 14.5 7.72386 14.5 8C14.5 9.72391 13.8157 11.3777 12.5967 12.5967C11.3777 13.8157 9.72391 14.5 8 14.5H7.99805C6.19178 14.4932 4.45789 13.7886 3.15918 12.5332L1.64649 11.0205C1.45128 10.8253 1.45139 10.5088 1.64649 10.3135C1.84175 10.1182 2.15826 10.1182 2.35352 10.3135L3.8545 11.8135L4.06739 12.0098C5.15337 12.9627 6.54972 13.4933 8.00098 13.499C9.45932 13.4988 10.8575 12.9199 11.8887 11.8887C12.9201 10.8572 13.5 9.45869 13.5 8Z"
      fill="currentColor"
    />
    <path
      d="M1.5 13.9997V10.6667C1.5 10.3905 1.72386 10.1667 2 10.1667H5.33301C5.60915 10.1667 5.83301 10.3905 5.83301 10.6667C5.83301 10.9428 5.60915 11.1667 5.33301 11.1667H2.5V13.9997C2.5 14.2758 2.27614 14.4997 2 14.4997C1.72386 14.4997 1.5 14.2758 1.5 13.9997Z"
      fill="currentColor"
    />
  </svg>
);
